<template>
  <div class="runnerSectionContainer">
    <div class="runnerSectionMainContainer">
      <v-data-table class="runnersSection" :items="race.competitors" hide-default-footer :headers="headers" :items-per-page=9999>
        <template v-slot:item="{ item }">
          <tr class="runnerHeight">
            <td class="text-start">
              <div style="float:left;width: 27px; border: 1px solid rgb(216, 216, 216); background-color: rgb(255, 255, 255); font-weight:900; text-align: center;margin-bottom:3px;margin-top:3px;">
                <div style="line-height:25px;">{{ item.tabNo }}</div>
              </div>
              <div class="float-left pl-1" v-if="meeting.type === 'GREYHOUND'">
                <RaceRunners :meeting="meeting" :race="race" :item="item"/>
              </div>
            </td>
            <td v-if="meeting.type !== 'GREYHOUND'" style="cursor: pointer;">
              <SilksPopup :item="item"/>
            </td>
            <td><v-img :src="image(item.tabNo)" max-height="64" max-width="64"></v-img></td>
            <td class="text-start font-weight-medium pl-1 runnerNameDiv">
              <div style="float:left;" class="runnerNameContainer">
                <div class="runnerNameBoxContent">
                  <div>
                    <div class="runnerNameBoxBets runnerNameBoxEnlarge mt-n1">
                      <div class="runnerNameBox">
                        <div class="font-weight-bold runnerName d-inline mr-2" style="width: 100%;">
                          {{ item.name }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>

// import Scratch from './Scratch'
// import ChangeJockey from './ChangeJockey'
import RaceRunners from './RaceRunners'
import SilksPopup from './SilksPopup'

export default {
  data: () => ({
    headers: [
      {
        text: 'Runner No',
        value: 'runnerNo'
      },
      {
        text: 'New Silk',
        value: 'newSilk'
      },
      {
        text: 'GBS Example',
        value: 'gbsExample'
      },
      {
        text: 'Runner Name',
        value: 'runnerName'
      }
    ],
    silksDialog: false,
    runner: null
  }),
  props: {
    race: Object,
    meeting: Object,
  },
  components: {
    /* Scratch,
    ChangeJockey, */
    RaceRunners,
    SilksPopup
  },
  methods: {
    image (v) {
      if (this.race?.meeting?.externalIDs) {
        const url = 'https://d1o4owrv8e0i8g.cloudfront.net/' +
                this.race?.meeting?.externalIDs[0]?.id +
                '_' +
                this.race.number +
                '_' +
                v +
                '_64x64.png'
        return url
      } return '@/assets/default_silk.png'
    }
  },
}
</script>

<style>
  .runnerSectionMainContainer {
    padding-bottom: 30px;
    z-index: 202;
    height: 100%;
  }
  .runnerSectionContainer {
    width: 100%;
    height: 100%;
    background:#fff;
    z-index: 202;
    min-width: 245px !important;
  }
  .runnersSection {
    width: 100%;
    border-top: 1px solid #efefef;
    border-bottom: 1px solid #efefef;
  }
  td.headerNameRunner {
  font-size: 0.9em;
  font-weight: 300;
  color: #555;
  vertical-align: bottom;
  width: 300px;
  height:34px;
  }
  .runnerHeight {
    height:32px !important
  }

  .runnerHeight:hover {
    background-color: #EFEFEF;
  }

  .cardRunnerButtons:hover {
    background-color: #EFEFEF;
  }
  
  .runnerNameBoxContent {
    width:250px;
    white-space: nowrap;
    overflow: hidden;
  }
  .runnerNameContainer {
    display: -webkit-flex;
    display: -moz-flex;
    display: flex;
    max-width:185px;
    height:30px;
  }
  .runnerNameBox {
    float: left;
    width: 100%;
    height:29px;
    white-space: nowrap;
    overflow: hidden;
  }
  .runnerNameBoxEnlarge {
    float: left;
    width: 100%;
    height:29px;
    white-space: nowrap;
    overflow: hidden;
  }
  .runnerNameBoxBets {
    float: left;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    padding-top:3px;
  }
  .runnerName {
    float:left;
    color: #333;
    overflow: hidden;
    max-width:180px;
  }
  .runnersButton {
    margin-left: 15px !important;
  }
</style>
